module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAAXNSR0IArs4c6QAAARJJREFUOE/d06FKBFEUBuD/P8wsMhaDwWAwjdXgQxh8gAWLZQaDoCYVXEQ0GATLRsUXMBp8AIM2ozAGuwbDgsydufwyy65M2F3Hjd56D99/zj1cpml6LOmA5Az+fnqStpgkydeUQD9S0jPTNJWkW5JLAFabNiPpjuQcgMUhcpFl2WEcx5sATgEsTMBevPd73vvHMAxvSK70kUFbrwC2i6J4arVa+5J262NK+iR55Jy7DoJgw8zOBmFvP0gt+b4sywrwZnZJck3SFcmO937ZzLpVeq1+JFLdlwC6zrmTPM+DKIpmzeycZHvEmGORYe1H9YAA2hM2+CvSZFn/EXkHMN9k+DE1D9XfWSe5IymYAuoB6HwDVUJ/lZ7sKJwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/email_.png
// module id = mVpv
// module chunks = 2